import React from 'react';
import { Field } from 'react-redux-form';

import styles from './CheckboxField.css';

export default function CheckboxField(props) {
  const { label, ...otherProps } = props;

  return (
    <label className={styles.checkboxContainer}>
      <Field {...otherProps}>
        <input type="checkbox" />
      </Field>
      <div className={styles.label}>
        {props.label}
      </div>
    </label>
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/CheckboxField.js
 **/